<template>
    <div v-if="content" v-editable="content" id="test-lib">
        <div class=" max-w-3xl mx-auto">
            <h1 class="text-center my-8">Test billetterie classique
                <osv-basket-icon />
            </h1>
            <div class="grid gap-10 grid-cols-2">
                <div>
                     <osv-cart-product />
                </div>
                <div class="static">
                    <osv-activity-calendar activityids="26,1" />
                    <div class="flex items-center my-20">
                        <custom-btn left-icon="shopping-bag" link="/fr/cart/product">Accéder à mon panier</custom-btn>
                    </div>
                </div>
                
            </div>

        </div>
    </div>
</template>

<script>
import api from "@/api";
export default {
    name: "home",
    data() {
        return {
            content: null
        };
    },
    created() {
        this.fetchData();
    },
    methods: {
        async fetchData() {
            const { data } = await api.get(
                `cdn/stories/${this.$i18n.locale}/pages/test-lib`
            );
            this.content = data.story.content;
        }
    }
};
</script>

<style lang="scss">
</style>

